import { TMassPostSaleJob } from 'redux/reducers/massPostSaleJobs/types';
import { DATE_FILTER } from 'ui/EasTable/constants';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import {
	EMassPostSaleJobOrderProcessingType,
	MASS_POST_SALE_JOBS_ACTIONS,
	MASS_POST_SALE_JOB_ORDER_PROCESSING_TYPE_FILTER,
	MASS_POST_SALE_JOB_STATUS_COLORS,
	MASS_POST_SALE_JOB_STATUS_FILTER,
} from './constants';

export const tableStructure: TTableStructure<keyof TMassPostSaleJob>[] = [
	{
		selector: 'id',
		name: 'id',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		key: true,
	},
	{
		selector: 'jobId',
		name: 'Job ID',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'processingType',
		name: 'Processing Type',
		show: true,
		sortable: true,
		filterable: true,
		filter: MASS_POST_SALE_JOB_ORDER_PROCESSING_TYPE_FILTER,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		selector: 'emId',
		name: 'EM',
		show: true,
		sortable: true,
		filterable: false,
		searchable: false,
		type: ETableStructureType.EM,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		value: (item: TMassPostSaleJob) => {
			return { id: item.emId, name: item.emFullName ?? '' };
		},
	},
	{
		selector: 'jobCreated',
		name: 'Carted Date',
		show: true,
		sortable: true,
		filterable: true,
		filter: DATE_FILTER,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		selector: 'status',
		name: 'Status',
		show: true,
		sortable: true,
		filterable: true,
		filter: MASS_POST_SALE_JOB_STATUS_FILTER,
		colors: MASS_POST_SALE_JOB_STATUS_COLORS,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'totalOrders',
		name: 'Total Orders',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'processedOrders',
		name: 'Processed',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'partialOrders',
		name: 'Partial',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'rejectedOrders',
		name: 'Rejected',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'warningOrders',
		name: 'Warnings',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'notified',
		name: 'Notified',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		selector: 'actions',
		noName: true,
		name: 'Actions',
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		buttonFilter: () => {
			return [
				{
					name: MASS_POST_SALE_JOBS_ACTIONS.VIEW_ORDERS,
					label: MASS_POST_SALE_JOBS_ACTIONS.VIEW_ORDERS,
					icon: EIconButtons.TABLE_CHART,
				},
			] as TTableStructureButton[];
		},
	},
];
